<section class="v-section" *ngIf="wheelData">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <a style="cursor:pointer" (click)="goBack()" class="black mt-3 mt-md-0"><i class="fa fa-long-arrow-left"
                        aria-hidden="true"></i></a>
            </div>
            <div class="col-md-4 col-xl-5 sm-0">
                <div class="container mt-4">
                    <div class="row">
                        <div class="col-md-12">
                            <!-- <h2 class="light-head mt-4 hide-large mb-heading">
                                {{ wheelData.brand.name }} <br /> {{ wheelData.model.name }} {{ finishName }}
                            </h2> -->

                            <div class="light-head mt-4 hide-large mb-heading">
                                <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 product-top">
                                    <h2 class="bold mb-2">{{ wheelData.brand.name }}</h2>
                                    <div class="increase-font2 d-flex flex-column">
                                        <span class="mb-2 fw-sb">{{ wheelData.model.name }} {{ finishName }}</span>
                                    </div>
                                </div>
                            </div>

                            <div id="custCarousel" class="carousel slide" data-ride="carousel" align="center">
                                <!-- slides -->
                                <div class="carousel-inner">
                                    <img [src]="'/placeholder.png' | imagePath" *ngIf="!wheelData.images" />
                                    <div class="carousel-item" [class.active]="i == 0"
                                        *ngFor="let image of wheelData.images; let i=index">
                                        <img [src]="image | imagePath" alt="img" (click)="showLightbox(0)"
                                            class="img-fluid">
                                    </div>
                                </div>
                                <!-- Left right -->
                                <a class="carousel-control-prev" href="#custCarousel" data-slide="prev">
                                    <span class="carousel-control-prev-icon"></span>
                                </a>
                                <a class="carousel-control-next" href="#custCarousel" data-slide="next">
                                    <span class="carousel-control-next-icon"></span>
                                </a>

                                <!-- Thumbnails -->
                                <ol class="carousel-indicators list-inline carousel-indicators-slides ">
                                    <li class="list-inline-item active" [class.active]="i == 0"
                                        *ngFor="let image of wheelData.images; let i=index">
                                        <a id="carousel-selector-0" class="selected" data-slide-to="0"
                                            data-target="#custCarousel">
                                            <img [src]="image | imagePath" alt="img" class="img-fluid">
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8 col-xl-7">
                <div class="row">
                    
                    <!-- <div class="col-md-12 col-xl-12 col-12">
                        <div class="col-md-12">
                            <h3 class="text-uppercase new-font bold">{{ wheelData.brand.name }}</h3>
                            <p class="f1 d-flex justify-content-between align-items-center new-font bold">{{ wheelData.model.name }} {{ finishName }}</p> 
                           
                        </div>
                        <div class="product-top">
                            <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">
                                <h6 class="mb-0">Supplier: {{ wheelData.vendor?.business_name }}</h6>
                     
                                <h6 class="mb-0">Part No : {{ wheelData.variant?.sku }}</h6>
                            </div>
                            <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 flex-column increase-font2">
                                <div class="product-top align-items-center flex-column">
                                    <div class="col-md-12 col-sm-12 col-xs-12 p-0 justify-content-end d-flex increase-font2">
                                        <span>List Price:</span>
                                        <span class="ml-3">{{ wheelData.variant?.us_retail_price | currency: product?.vendor?.curency:'symbol' }} /each </span>
                                    </div>
                                    <div class="col-md-12 justify-content-end d-flex increase-font2 p-0" *ngIf="wheelData.discounted_price > 0 && is_hide_cost == null">
                                        <span class="bold">Your Price:</span>
                                        <span class="ml-3 bold">{{ wheelData.discounted_price | currency: product?.vendor?.curency:'symbol' }} /each</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-md-12 col-xl-12 col-12 f-details">
                        <div class="product-top">
                            <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">
                                <h2 class="bold mb-2 d-none d-md-block">{{ wheelData.brand.name }}</h2>
                                <div class="increase-font2 d-flex flex-column">
                                    <span class="mb-2 fw-sb d-none d-md-block">{{ wheelData.model.name }} {{ finishName }}</span>
                                    <span class="mb-0 fw-sb si-red">SKU : {{ wheelData.variant?.sku }}</span>
                                </div>
                            </div>

                            <div
                                class="col-md-12 col-lg-6 col-sm-12 col-xs-12 flex-column increase-font2 d-flex justify-content-between">
                                <div class="product-top d-flex align-items-end flex-column">
                                    <div class="increase-font2">
                                        <span class="bold npc">MSRP:</span>
                                        <span class="ml-3 bold npc">{{ wheelData.variant?.us_retail_price | currency:
                                            product?.vendor?.curency:'symbol' }}</span>
                                    </div>
                                    <div class="increase-font2 p-0 "
                                        *ngIf="wheelData.discounted_price > 0 && is_hide_cost == null">
                                        <span class="bold npc pb">Your Price:</span>
                                        <span class="ml-3 bold npc pb">{{ wheelData.discounted_price | currency:
                                            product?.vendor?.curency:'symbol' }}</span>
                                    </div>
                                    <div class="increase-font2 p-0 "
                                    *ngIf="wheelData.clearance_corner" >
                                        <span class="bold npc pb">Sale Price:</span>
                                        <span class="ml-3 bold npc pb">{{ wheelData?.variant?.sale_price | currency:
                                            product?.vendor?.curency:'symbol' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-md-12 d-flex justify-content-between align-items-center mt-4 mb-3 border-tb pt-4 pb-4" *ngIf="vendor_is_approved">

                        <div class="d-flex align-items-center col-md-6 f-details pl-0 ">
                            <div class="custom-label new-quantity-box">
                                <div class="input-group custom-adder custom-adder-rw position-relative">
                                    <input type="button" value="-" class="button-minus"
                                        (click)="decrementQuantity(wheelData.variant.id, wheelData.in_stock_quantity, wheelData.eta_quantity)"
                                        [disabled]="prodQty[wheelData.variant.id] <= minQuantity" />
                                    <input type="number" step="1" [min]="minQuantity"
                                        [(ngModel)]="prodQty[wheelData.variant.id]" name="quantity"
                                        class="quantity-field" />
                                    <input type="button" value="+" class="button-plus"
                                        (click)="incrementQuantity(wheelData.variant.id, wheelData.in_stock_quantity, wheelData.eta_quantity)">

                                    <label class="f-light">Quantity</label>
                                </div>
                            </div>

                            <div class="">
                                <p class="mb-0 cp text-du pl-2 max-text" *ngIf="wheelData.in_stock_quantity>0" data-toggle="modal"
                                    (click)="getInventoryByProduct(wheelData.id, wheelData.variant.id)"
                                    data-target="#stockModal">{{ wheelData.in_stock_quantity }} in stock</p>
                                <p class="mb-0 cp text-du pl-2 max-text"
                                    *ngIf="wheelData.in_stock_quantity<=0 && wheelData.eta_quantity>0"
                                    data-toggle="modal"
                                    (click)="getInventoryByProduct(wheelData.id, wheelData.variant.id)"
                                    data-target="#stockModal">{{ eta }}</p>
                                <p class="mb-0 pl-2" *ngIf="wheelData.in_stock_quantity<=0 && wheelData.eta_quantity<=0">Out
                                    of stock </p>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-end col-md-6 pr-0" *ngIf="getTotalQtyProduct(inventory) > 0 || wheelData.eta_quantity > 0">
                            <!-- <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn" *ngIf="!(productCartTotalQty[wheelData.variant.id] === undefined || productCartTotalQty[wheelData.variant.id] <= 0)" (click)="onAddToCart(product)"> -->
                            <button type="button"
                                class="btn btn-02 f-large addcart new-btn cart-btn text-uppercase"
                                [disabled]="prodQty[wheelData.variant.id] <= 0 && wheelData.eta_quantity > 0" (click)="onAddToCart()">
                                <app-preloader *ngIf="cartProcessing"></app-preloader>
                                <span *ngIf="!cartProcessing">ADD TO CART </span>
                            </button>
                        </div>


                    </div>
                    <div class="col-md-12 mb-3">
                        <div class="card border-0">
                            <div class="card-header bg-black text-white">
                                Specifications
                            </div>
                            <div class="card-body p-0 overflow-hidden">
                                <div class="row new-font row-m-0" style="font-weight: 500;">
                                    <div class="col-md-12 p-0">
                                        <div class="row bg-grey">
                                            <div class="col-md-6 d-flex">
                                                Size: {{ wheelData.variant.size }}
                                            </div>
                                            <div class="col-md-6 d-flex">
                                                Bolt Pattern: {{ wheelData.variant.bolt_pattern }}
                                                
                                            </div>
                                        </div>
                                        <div class="row bg-grey">
                                            <div class="col-md-6 d-flex">
                                                Offset: {{ wheelData.variant.offset }}
                                            </div>
                                            <div class="col-md-6 d-flex">
                                                Center Bore: {{ wheelData.variant.hub_bore }}
                                               
                                            </div>
                                        </div>
                                        <div class="row bg-grey">
                                            <div class="col-md-6 d-flex">
                                                Weight: {{ wheelData.variant.weight }}
                                            </div>
                                            <div class="col-md-6 d-flex">
                                                Load Rating:  {{ wheelData.variant.max_wheel_load }}
                                            </div>
                                        </div>
                                        <div class="row bg-grey">
                                            <div class="col-md-6 d-flex">
                                                Lip Size:  {{ wheelData.variant.lipsize }}
                                            </div>
                                            <div class="col-md-6 d-flex">
                                                Construction: {{ wheelData?.construction }}
                                            </div>
                                        </div>
                                        <div class="row bg-grey">
                                            <div class="col-md-6 d-flex">
                                                Warranty: {{ wheelData.variant.backspacing }}
                                            </div>
                                        </div>

                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                   


                    <div class="col-md-12">
                        <div class="detail-accordian-wrap">
                            <div class="accordion left-sidebar" id="accordionExampleTwo">
                                <div class="card">
                                    <div class="card-header " id="headingOne">
                                        <h2 class="mb-0">
                                            <button type="button" class="btn btn-link bg-black text-white"
                                                data-toggle="collapse" data-target="#collapseOne">
                                                FITS
                                                <i class="fa fa-chevron-down text-white"></i>
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseOne" class="collapse true" aria-labelledby="headingOne"
                                        data-parent="#accordionExampleTwo">
                                        <div class="card-body bg-grey ">
                                            <ul>
                                                <li *ngFor="let fits of wheelFitsData">{{ fits.year_ranges[0] }} {{
                                                    fits.make.name}} {{ fits.name}}</li>
                                                <li *ngIf="wheelFitsData.length <= 0">No fits found.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="b-line"></div>

                <!-- <div class="row mt-1 mt-md-4 text-center" *ngIf="finishes && finishes.length > 0">
                    <div class="col-md-12">
                        <h2 class="text-left f-26">More Finishes</h2>
                    </div>
                    <div class="col-6" *ngFor="let item of finishes">
                        <a [routerLink]="['/', item.slug, variantID]" class="no-styling">
                            <img *ngIf="item.images" [src]="item.images[0] | imagePath" class="img-fluid" alt="img" />
                            <img *ngIf="!item.images" [src]="'/placeholder.png' | imagePath" class="img-fluid" alt="img" />
                            <h3 class="mt-2 mb-4 u-head">{{ item.finish.finish}}</h3>
                            <h5>{{ item.us_retail_price | currency: ' $ ' }}</h5>
                        </a>
                    </div>
                </div> -->
            </div>


        </div>

        <div class="row" *ngIf="wheelSizeTypes.length > 0">
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                <h2 class="text-left f-26 new-font mb-3" style="font-weight: 600;">More Size & Options</h2>
            </div>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 ">
                <ul class="nav nav-tabs nav-justified search-nav-tabs details-tabs">
                    <li class="nav-item" *ngFor="let type of wheelSizeTypes; let i = index">
                        <a class="nav-link" [ngClass]="i == 0 ? 'active' : ''" [class.active]="activeTab==''" data-toggle="tab" href="{{type}}"
                            (click)="getVariantsData(wheelData.id, wheelData.variant.id, type)">{{ type }}″</a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                <div class="table-responsive">
                    <table class="table details-table ">
                        <thead>
                            <tr>
                                <th>Part No.</th>
                                <th>Finish</th>
                                <th>Size</th>
                                <th>Bolt Pattern</th>
                                <th>Offset</th>
                                <th>Weight</th>
                                <th>Stock</th>
                                <th> </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="moreSizes.length > 0">
                            <tr *ngFor="let size of moreSizes">
                                <td><a [routerLink]="['/', id, size.sku]" class="no-styling">{{ size.sku }}</a></td>
                                <td>{{ wheelData?.finish?.finish }}</td>
                                <td>{{ size.size }}</td>
                                <td>{{ size.bolt_pattern }}</td>
                                <td>{{ size.offset }}</td>
                                <td>{{ size.weight }}</td>
                                <td *ngIf='size.total_quantity > 0'><span class='in-stk'>In Stock</span></td>
                                <td *ngIf='size.total_quantity <= 0'><span class='out-stk'>Out Of Stock</span></td>
                                <td><a [routerLink]="['/', id, size.sku]" class="no-styling">View</a></td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="moreSizes.length <= 0">
                            <tr>
                                <td colspan="8">No more sizes found.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</section>





<!-- Footer Top Blue Bar -->
<section class="colored-section-bordered d-none">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 col-xl-10 offset-xl-1">
                <div class="row">
                    <div class="col-4 col-xl-4 d-flex">
                        <div class="image-div w-100">
                            <img src="../../../../assets/img/ic1_11.png" class="img-fluid" alt="img" />
                            <p>FREE INSTALLATION</p>
                        </div>
                    </div>
                    <div class="col-4 col-xl-4 d-flex">
                        <div class="image-div w-100">
                            <img src="../../../../assets/img/ic2_11.png" class="img-fluid" alt="img" />
                            <p>FITMENT GUARANTEE</p>
                        </div>
                    </div>
                    <div class="col-4 col-xl-4 d-flex">
                        <div class="image-div w-100">
                            <img src="../../../../assets/img/ic3_11.png" class="img-fluid" alt="img" />
                            <p>BEST PRICES</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>


<!-- postpy popup -->
<div
    [ngClass]="(showpostpaypopup=='yes')?'postpay-learn-more-modal-content-wrapper':'postpay-learn-more-modal-content-wrapper d-none'">
    <div class="postpay-learn-more-modal-content">
        <div class="postpay-learn-more-modal-close" (click)="hidePostPayPopup()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 21.58 21.579">
                <defs>
                    <style>
                        .cls-1 {
                            fill: #022244;
                            stroke: #022244
                        }
                    </style>
                </defs>
                <g id="Group_2705" data-name="Group 2705" transform="translate(-1224.245 -285.246)">
                    <g id="Group_1926" data-name="Group 1926" transform="rotate(-45 979.258 -1326.723)">
                        <path id="Path_926" d="M32.23 17.846H10.121a1.6 1.6 0 1 1 0-3.2H32.23a1.6 1.6 0 0 1 0 3.2z"
                            class="cls-1" data-name="Path 926" transform="translate(-8.518 -14.641)"></path>
                    </g>
                    <g id="Group_1927" data-name="Group 1927" transform="rotate(-45 960.388 -1334.54)">
                        <path id="Path_927"
                            d="M16.244 33.831a1.6 1.6 0 0 1-1.6-1.6v-22.11a1.6 1.6 0 1 1 3.2 0V32.23a1.6 1.6 0 0 1-1.6 1.601z"
                            class="cls-1" data-name="Path 927" transform="translate(-14.641 -8.518)"></path>
                    </g>
                </g>
            </svg>
        </div>
        <div class="postpay-modal-title">Postpay</div>
        <div class="postpay-modal-description">
            3 interest-free monthly payments
        </div>
        <div class="postpay-how-it-works-container">
            <div class="postpay-how-it-works-item">
                <div class="postpay-how-it-works-item-title">
                    Sign up in seconds.
                </div>
                <div class="postpay-how-it-works-item-description">
                    No long forms to fill. You will receive an instant approval decision. Valid for orders up to <div
                        class="postpay-product-price-wrapper">
                        <span class="postpay-pay-later-item-currency">$</span>
                        <span class="postpay-product-price">
                            5,000
                        </span>
                    </div>.
                </div>
            </div>

            <div class="postpay-how-it-works-item">
                <div class="postpay-how-it-works-item-title">Split your purchase in 3.</div>
                <div class="postpay-how-it-works-item-description">
                    First payment is processed today. Remaining 2 payments are processed automatically every month.
                </div>
            </div>

            <div class="postpay-how-it-works-item">
                <div class="postpay-how-it-works-item-title">
                    No interest. No fees.
                </div>
                <div class="postpay-how-it-works-item-description">
                    Postpay is always interest-free and you only pay for what you purchase.
                </div>
            </div>
        </div>
        <div class="postpay-learn-more-modal-action">
            Select <a href="#" target="_blank" class="postpay-brand postpay-link">postpay</a> as your payment method at
            checkout.
        </div>
        <div class="postpay-learn-more-modal-footer">
            All you need to apply is your debit or credit card. You must be over 18 and a UAE resident. <a href="#"
                target="_blank" class="underline">Terms and Conditions apply.</a>
            <br>
            You can reach us on <a href="#">support&#64;postpay.io</a> or +971-4215-6555.
        </div>
    </div>
</div>

<button class="btn btn-lg btn-outline-primary" id="auto_trigger" style="display: none;"
    (click)="openModal(detailpagemodal)">Open Add On Modal</button>

<ng-template #detailpagemodal let-modal>
    <!-- <div class="modal-header pl-0 fntres">


        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6">
                    <h4 class="modal-title" id="modal-basic-title"> : {{ cartResp.total | currency: '$ '}}</h4>


                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <button type="button" class="btn btn-02 mb-1" aria-label="Close" (click)="modal.dismiss('Cross click')">Continue Shopping</button>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <button type="button" class="btn btn-04" (click)="closeModalAndRedirectCart()">Checkout</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">x</span>
    </button>

    </div> -->

    <!-- new modal header -->
    <div class="modal-header pl-0 fntres pt-0 pb-0">
        <div class="container">

            <div class="row">
                <button type="button" class="close modal-close-btn" aria-label="Close"
                            (click)="modal.dismiss('Cross click');resetProdCustomizationProperties()">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                                        fill="#0F0F0F"></path>
                                </g>
                            </svg>
                        </button>
                <div class="col-md-8">
                    <div class="cart-left">
                        <!-- <div class="alert alert-success" role="alert" *ngIf="successMessage">
                    <svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="16" height="16" id="icon-bound" fill="none"></rect> <path d="M0,9.014L1.414,7.6L5.004,11.189L14.593,1.6L16.007,3.014L5.003,14.017L0,9.014Z"></path> </g></svg>
                      {{successMessage}}
                  </div> -->

                        <div class="cart-product-row">
                            <div class="position-relative">
                                <span class="tip">{{ productCartTotalQty }}</span>
                                <img [src]="wheelData.images[0] | imagePath" alt="Product" />
                            </div>
                            <div class="cart-left-title">
                                <h4>{{wheelData.product_full_name}}</h4>
                                <div class="d-flex flex-column gap-1">

                                    <p class="mb-0">Part No: {{ wheelData.variant?.sku  }}</p>
                                    <p class="mb-0">Size: {{ wheelData.variant.size }}</p>
                                    <p class="mb-0">Bolt Pattern: {{  wheelData.variant.bolt_pattern  }}</p>
                                    <p class="mb-0">Offset: {{ wheelData.variant.offset }}</p>
                                    <!-- <strong *ngIf="is_hide_cost == null">{{ wheelData?.discounted_price | currency:
                                      wheelData?.vendor?.currency:'symbol' }} / Each</strong>
                                    <strong *ngIf="is_hide_cost != null">{{ wheelData?.price | currency:
                                      wheelData?.vendor?.currency:'symbol' }} / Each</strong> -->
                                  </div>

                                <div class="form-group mt-2">
                                    <input class="form-control" type="text" [(ngModel)]="vehicle_year_make_model"
                                        placeholder="Enter Vehicle year make model to ensure fitment" />
                                    <span *ngIf="p_customization_submitted">
                                        <span class="error"
                                            *ngIf="(bolt_pattern == 'recommended' || offset == 'recommended') && !vehicle_year_make_model">This
                                            field is required</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 ">


                    <div class="cart-right">
                        
                        <h5 class="modal-title text-center" id="modal-basic-title" *ngIf="!isProductCustomization">Your
                            current cart value: {{ cartResp.total | currency: '$ '}}</h5>
                        <button type="button" class="btn btn-003 mb-1" aria-label="Close"
                            (click)="modal.dismiss('Cross click')" *ngIf="!isProductCustomization">Continue
                            Shopping</button>
                        <button type="button" class="btn btn-04" *ngIf="!isProductCustomization"
                            (click)="closeModalAndRedirectCart()">Checkout</button>
                        <div class="cart-right-row" *ngIf="isProductCustomization">
                            <div class="cart-right-row-inner"
                                *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].is_custom_finish">
                                <span>Custom Finish:</span>
                                <div>
                                    <select class="form-control custom-finish-control" [(ngModel)]="custom_finish"
                                        (change)="onCustomFinishSelect($event)">
                                        <option value="">Choose Finish</option>
                                        <option *ngFor="let p_customization of cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].product_customizations"
                                            [value]="p_customization.id">{{ p_customization.finish_name }} (+
                                            {{p_customization.cost | currency: '$' }})
                                        </option>
                                    </select>
                                    <span *ngIf="p_customization_submitted">
                                        <span class="error" *ngIf="!custom_finish">This field is required</span>
                                    </span>
                                </div>
                            </div>

                            <div class="cart-right-row-inner mt-20"
                                *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns && cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns.length>0">
                                <span>Bolt Pattern:</span>
                                <select class="form-control" [(ngModel)]="bolt_pattern">
                                    <option value="recommended">Recommended</option>
                                    <option *ngFor="let bolt_battern of cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].bolt_patterns" [value]="bolt_battern">
                                        {{ bolt_battern }}</option>
                                </select>
                            </div>

                            <div class="cart-right-row-inner mt-20"
                                *ngIf="cartResp.product_customizations[getFirstKey(cartResp.product_customizations)].is_offset_drilling && offsetDropdownValues && offsetDropdownValues.length>0">
                                <span>Offset:</span>
                                <select class="form-control" [(ngModel)]="offset">
                                    <option value="recommended">Recommended</option>
                                    <option *ngFor="let offset of offsetDropdownValues" [value]="offset">{{ offset }}
                                    </option>
                                </select>
                            </div>


                        </div>
                        <div class="mt-4 d-inline-flex justify-content-end p-0" *ngIf="isProductCustomization">
                            <button type="button" class="btn btn-02 f-large addcart ml-3 new-btn text-white w-auto"
                                (click)="addToCartFromProductCustomizationPopup()"><span>ADD TO CART</span></button>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
    <!-- ng-show="addons && addons.length > 0" -->
    <div class="modal-body" [hidden]="addons.length <= 0">
        <div class="container">
            <app-add-ons [addOns]="addons" [cartItems]="cartItems" [modal]="modal"></app-add-ons>
        </div>
    </div>
    <!-- <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button>
  </div> -->


</ng-template>
<!--  -->

<ng-image-fullscreen-view [images]="albums" [imageIndex]="selectedImageIndex" [show]="showFlag"
    (close)="closeEventHandler()"></ng-image-fullscreen-view>






<div class="modal fade stock-modal" id="stockModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header border-0">
                <h5 class="modal-title" id="exampleModalLabel">Inventory</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body border-0">
                <div class="d-flex flex-row align-items-center justify-content-center inventory_loader">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span>&nbsp;&nbsp;Fetching Data ...</span>
                </div>
                <div class="table-responsive inventory_table">
                    <table class="table cart-table">
                        <thead>
                            <tr>
                                <th>Warehouse</th>
                                <th>Quantity</th>
                                <th>Ship From</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let inventory of inventoryData; let i = index">
                                <td>{{inventory.warehouse_name}}</td>
                                <td>
                                    <span *ngIf="inventory.quantity>0">{{ inventory.quantity }}</span>
                                    <span *ngIf="inventory.quantity<=0">{{ inventory.eta_qty }} {{
                                        inventory.eta}}</span>
                                </td>
                                <td>
                                    <input type="radio" name="stock" [checked]="i === 0"
                                        (change)="setWarehouse(inventory.id)" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>